import { CircularProgress, Menu, MenuItem } from '@material-ui/core';
import Button from 'shared/components/Button';
import { ViajeTrasladoTipoServicio } from 'app/viaje/models';
import { TransferReservationManagmentModel } from 'app/viaje/viajeTraslado/gestion/models/TransferReservationManagment';
import { TransferReservationPendingModel } from 'app/viaje/viajeTraslado/pendiente/models/TransferReservationPending';
import { copyReservationPublicNewLinkToClipboard } from 'app/viaje/viajeTraslado/viajeTraslado/services/copyReservationPublicLinkToClipboard';
import { contingencyService } from '../../services/contingencyService';
import { useSnackbar } from 'notistack';
// import { useSnackbar } from '@vadiun/react-hooks';
import React from 'react';

type Props = {
  current: any;
  index: number;
  onAssignDriver: (driver: any, isContingency: boolean) => void;
  onPreAssignDriver: (driver: any) => void;
  onRemovePreAssigned: (driver: any) => void;
  onReservationShowDetails: (id: number) => React.ReactNode;
  onReservationCopyDetails: (
    reservation: TransferReservationPendingModel
  ) => void;
  onEditReservation: (travel: TransferReservationPendingModel) => void;
  onReservationCopy: (reservation: TransferReservationManagmentModel) => void;
  onCancelReservation: (reservation: TransferReservationPendingModel) => void;
  onDelayNotify: (travel: TransferReservationPendingModel) => void;
  onStartTravel: (selectedReservation: number, chofer: number) => void;
  onBusesPreAssign: (travel: TransferReservationPendingModel) => void;
};

const ActionsItemCordinate = ({
  current,
  index,
  onAssignDriver,
  onPreAssignDriver,
  onRemovePreAssigned,
  onReservationShowDetails,
  onReservationCopyDetails,
  onCancelReservation,
  onEditReservation,
  onReservationCopy,
  onDelayNotify,
  onStartTravel,
  onBusesPreAssign
}: Props) => {
  const snackbar = useSnackbar();
  const { getActiveContingencies } = contingencyService();

  const eventIndex = React.useRef<number | null>(null);
  const [driverButtonElement, setDriverButtonElement] = React.useState<
    (EventTarget & HTMLElement) | null
  >(null);
  const [reservationButtonElement, setReservationButtonElement] =
    React.useState<(EventTarget & HTMLElement) | null>(null);
  const [hasActiveContingency, setHasActiveContingency] = React.useState(false);
  const [isLoadingContingency, setIsLoadingContingency] = React.useState(false);

  return (
    <div className='flex flex-col gap-2'>
      <Button
        onClick={async (ev) => {
          ev.stopPropagation();
          const target = ev.currentTarget;
          setIsLoadingContingency(true);
          try {
            const actives = await getActiveContingencies();
            setHasActiveContingency(actives.length > 0);
          } catch {
            setHasActiveContingency(false);
            snackbar.enqueueSnackbar('Error al verificar contingencias activas', { variant: 'error' });
          } finally {
            setIsLoadingContingency(false);
            eventIndex.current = index;
            setDriverButtonElement(target);
          }
        }}
        variant='dashed'
      >
        <span className="flex items-center gap-2">
          Chofer
          {isLoadingContingency && (
            <CircularProgress size={12} style={{ color: 'inherit' }} />
          )}
        </span>
      </Button>
      <Menu
        anchorEl={driverButtonElement}
        open={eventIndex.current === index && Boolean(driverButtonElement)}
        onClose={(ev: any) => {
          ev.stopPropagation();
          setDriverButtonElement(null);
        }}
      >
        {current.serviceType ===
        ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES ? (
          <MenuItem
            onClick={(ev) => {
              ev.stopPropagation();
              setDriverButtonElement(null);
              onBusesPreAssign(current);
            }}
          >
            Pre-asignar
          </MenuItem>
        ) : (
          <MenuItem
            onClick={(ev) => {
              ev.stopPropagation();
              setDriverButtonElement(null);
              onPreAssignDriver(current);
            }}
          >
            Pre-asignar
          </MenuItem>
        )}
        <MenuItem
          onClick={(ev) => {
            ev.stopPropagation();
            setDriverButtonElement(null);
            onAssignDriver(current, false);
          }}
        >
          Asignar
        </MenuItem>
        {hasActiveContingency && (
          <MenuItem
            onClick={(ev) => {
              ev.stopPropagation();
              setDriverButtonElement(null);
              onAssignDriver(current, true);
            }}
          >
            Asignar con Contingencia
          </MenuItem>
        )}
        {current.preAssignedDriver?.codigo ? (
          <MenuItem
            onClick={(ev) => {
              ev.stopPropagation();
              setDriverButtonElement(null);
              onRemovePreAssigned(current.id);
            }}
          >
            Remover chofer
          </MenuItem>
        ) : null}
      </Menu>
      <Button
        onClick={(ev) => {
          ev.stopPropagation();
          eventIndex.current = index;
          setReservationButtonElement(ev.currentTarget);
        }}
        variant='dashed'
      >
        Reserva
      </Button>
      <Menu
        anchorEl={reservationButtonElement}
        open={eventIndex.current === index && Boolean(reservationButtonElement)}
        onClose={() => setReservationButtonElement(null)}
      >
        {onReservationShowDetails(current.id)}
        <MenuItem
          onClick={() => {
            onReservationCopyDetails(current);
            setReservationButtonElement(null);
          }}
        >
          Copiar detalles
        </MenuItem>
        <MenuItem onClick={() => onEditReservation(current)}>
          Modificar
        </MenuItem>
        <MenuItem onClick={() => onCancelReservation(current)}>
          Cancelar
        </MenuItem>
        <MenuItem onClick={() => onReservationCopy(current)}>Copiar</MenuItem>
        <MenuItem
          onClick={async () => {
            await copyReservationPublicNewLinkToClipboard(current.id);
            setReservationButtonElement(null);
            snackbar.enqueueSnackbar('Link de seguimiento copiado', {
              variant: 'info'
            });
          }}
        >
          Copiar link de seguimiento
        </MenuItem>
        <MenuItem
          onClick={() => {
            eventIndex.current = null;
            setReservationButtonElement(null);
            onDelayNotify(current);
          }}
        >
          Notificar Demora
        </MenuItem>
      </Menu>
      {current?.preAssignedDriver ? (
        <Button
          onClick={() => {
            onStartTravel(current.id, current.preAssignedDriver?.id!);
          }}
          variant='dashed'
          className='whitespace-nowrap'
        >
          Pasar a Abierto
        </Button>
      ) : null}
    </div>
  );
};

export default ActionsItemCordinate;
